class Dropdown extends HTMLElement {
  constructor() {
    super()

    this.header = this.querySelector('.dropdown-header')
    this.copy = this.querySelector('.dropdown-copy')
    this.initialiseDropdown()
  }

  initialiseDropdown() {

    this.header.addEventListener('click', () => {
      const pinBottom = window.matchMedia('(min-width: 901px)').matches
      const bottom = pinBottom ? this.getBoundingClientRect().bottom : 0

      this.copy.classList.toggle('active')
      this.copy.style.maxHeight = `${this.copy.scrollHeight + 20}px`
      this.header.classList.toggle('active')

      if (!this.copy.classList.contains('active')) {
        this.copy.style.maxHeight = '0px'
      }

      if (!pinBottom) return

      const delta = this.getBoundingClientRect().bottom - bottom
      if (!delta) return

      const root = document.documentElement
      const scrollBehavior = root.style.scrollBehavior
      root.dataset.headerScrollLock = '1'
      root.style.scrollBehavior = 'auto'
      window.scrollBy(0, delta)
      root.style.scrollBehavior = scrollBehavior
      window.requestAnimationFrame(() => {
        delete root.dataset.headerScrollLock
      })
    })

  }


}

customElements.define('dropdown-accordion', Dropdown)
